/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.finance.list.controllers', [
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.service.permissions',
  'acme.common.factory.notice',
  'acme.common.service.userPreferences'
])

.controller('FinanceListController', ['$scope', '$filter', 'ApiService', 'HelpersService', 'PermissionsService', 'NoticeFactory', 'UserPreferencesService', function($scope, $filter, ApiService, HelpersService, PermissionsService, NoticeFactory, UserPreferencesService) {

    $scope.financeList = {

      model: [],
      filtered: [],

      searchQuery: '',
      selected: false,
      isLoaded: false,
      isSubmitted: false,
      queryTimer: false,
      current: false,

      dateTimeFormat: UserPreferencesService.getDateTimeFormat('sortDateTime'),

      gridState: {
        page: 1,
        pageSize: 50,
        sortField: 'reportDate',
        sortDirection: 'desc'
      },

      grid: {
        pageSize: 50,
        showFooter: true,
        paginate: true,
        multiselect: true,
        enableRowSelection: false,
        useExternalSorting: true,
        useExternalPagination: true,
        columns: [
          {
            field: 'fileName',
            displayName: 'File'
          },
          {
            field: 'version',
            displayName: 'Version'
          },
          {
            field: 'reportDate',
            displayName: 'Date',
            cellTemplate: '<div class="ui-grid-cell-contents">{{ grid.appScope.dateFormat(row.entity.reportDate) }}</div>'
          },
          {
            field: 'action',
            displayName: '',
            onCellNavClick: function(row, col) {
              $scope.financeList.downloadFile(row.entity.fileName);
            },
            cellTemplate: '<div class="ui-grid-cell-contents"><a data-ng-click="grid.appScope.downloadFile(row.entity.fileName)">Download</a></div>',
            visible: PermissionsService.check('FINANCE_REPORTS_DOWNLOAD')
          }
        ],
        appScopeProvider: {
          downloadFile: function(name) {
            $scope.financeList.downloadFile(name);
          },
          dateFormat: function(date) {
            return $filter('date')(date, $scope.financeList.dateTimeFormat);
          }
        }
      },

      notice: new NoticeFactory(),

      init: function() {
        $scope.$emit('Application::contentTitleChange', {
          title: 'Finance'
        });

        this.getReports(this.gridState);
      },

      getReports: function(page) {
        ApiService.finance.reports.list(page).then(this.success.getReports, this.error.getReports);
      },

      downloadFile: function(name) {
        ApiService.finance.reports.download(name);
      },

      success: {
        init: function(response) {},
        getReports: function(response) {
          var self = $scope.financeList;

          self.filtered = response.data.payload.list;
          self.gridState.totalItems = response.data.payload.pagination.count;

          if (!$scope.$$phase) {
            $scope.$apply();
          }

          self.isLoaded = true;
        }
      },

      error: {
        init: function(response) {},
        getReports: function(response) {
          var self = $scope.financeList;
          self.isLoaded = true;
        }
      },

      onDataGridPaginate: function(newPage, pageSize) {
        var self = $scope.financeList,
          data = {
            currentPage: newPage || 1,
            pageSize: pageSize || 50,
            field: self.gridState.sortField,
            direction: self.gridState.sortDirection
          };
        self.gridState = {
          page: data.currentPage,
          pageSize: data.pageSize,
          sortField: data.field,
          sortDirection: data.direction
        };
        self.getReports(self.gridState);
      },

      onDataGridSortChange: function(grid, columns) {
        var self = $scope.financeList,
            data = columns[0];

        if(data) {
          data.currentPage = self.gridState.currentPage;
          data.pageSize = self.gridState.pageSize;
          self.gridState = {
            page: data.currentPage,
            pageSize: data.pageSize,
            sortField: data.field,
            sortDirection: data.sort.direction
          };
          self.getReports(self.gridState);
        }
      },

      onDestroy: function() {
        if ($scope.financeList.queryTimer) {
          $timeout.cancel($scope.financeList.queryTimer);
        }
      }

    };

    $scope.financeList.init();

}]);